import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@zillow/constellation';
import DTIFields from './DTIFields.js';
import DTIOutputTable from './DTIOutputTable.js';
import { FieldConfig, DEFAULT_VALUES_SHAPE } from './DTICalculator.utils.js';
export { DEFAULT_VALUES_SHAPE } from './DTICalculator.utils.js';
import { omitUndefined } from '../../utils/lodash.js';
import CalculatorForm from '../CalculatorForm/CalculatorForm.js';

var DTICalculator = function DTICalculator(_ref) {
  var _Object$assign;
  var defaultValues = _ref.defaultValues,
    editorMode = _ref.editorMode;
  return /*#__PURE__*/React.createElement(CalculatorForm, {
    editorMode: editorMode,
    fieldStorageKey: "DTIFields",
    calcTypeForMarketing: "DTI",
    defaultValues: Object.assign((_Object$assign = {}, _Object$assign[FieldConfig.annualIncome.name] = 70000, _Object$assign[FieldConfig.minCreditCardPayments.name] = 200, _Object$assign[FieldConfig.carLoanPayments.name] = 500, _Object$assign[FieldConfig.studentLoanPayments.name] = 300, _Object$assign[FieldConfig.alimonySupportPayments.name] = 0, _Object$assign[FieldConfig.secondaryHomeExpenses.name] = 0, _Object$assign[FieldConfig.otherDebtPayments.name] = 0, _Object$assign), omitUndefined(defaultValues))
  }, /*#__PURE__*/React.createElement(Box, {
    sx: {
      paddingBottom: '$spacing.sm',
      display: 'flex',
      flexDirection: 'column-reverse',
      '@media $lg': {
        'flex-direction': 'row',
        'justify-content': 'space-between'
      }
    }
  }, /*#__PURE__*/React.createElement(Box, {
    sx: {
      flexShrink: 0,
      '@media $md': {
        flexBasis: '30%'
      },
      '@media $lg': {
        marginRight: '$spacing.sm'
      }
    }
  }, /*#__PURE__*/React.createElement(DTIFields, null)), /*#__PURE__*/React.createElement(Box, {
    sx: {
      '@media $md': {
        'flex-basis': '65%'
      }
    }
  }, /*#__PURE__*/React.createElement(DTIOutputTable, null))));
};
DTICalculator.defaultProps = {
  defaultValues: undefined,
  editorMode: undefined
};
DTICalculator.propTypes = process.env.NODE_ENV !== "production" ? {
  defaultValues: PropTypes.shape(DEFAULT_VALUES_SHAPE),
  editorMode: PropTypes.bool
} : {};
var DTICalculator$1 = DTICalculator;

export { DTICalculator$1 as default };
